<!--
component: BrowseBuilding1men
author: Ken Nakamura
description: 建築計画概要書（第一面）
-->
<template>
  <section class="A4">
    <p class="gaiyo-annotation">
      注：この建築計画概要書は申請時に提出された原本ではなく、入力データから再構築したものです。
    </p>
    <p v-show="firstPart <= 1 && lastPart >= 1"
      class="gaiyo-youshiki">
      第三号様式（第一条の三、第六条の三、第十一条の四関係）（Ａ４）
    </p>
    <div id="gaiyo-1men" ref="gaiyo-1men">
      <p v-show="firstPart <= 1 && lastPart >= 1"
        class="gaiyo-section-header">
        建築計画概要書（第一面）
      </p>
      <div v-show="firstPart <= 1 && lastPart >= 1"
        class="gaiyo-section-subheader">建築主等の概要
      </div>
      <div v-show="firstPart <= 1 && lastPart >= 1">
        <BrowseBuildingOwner :owners="gaiyo.nushi"
          :startIndex="ownerStart" :endIndex="ownerEnd" />
        <hr>
      </div>
      <div v-show="firstPart <= 2 && lastPart >= 2">
        <BrowseBuildingDairi :dairis="gaiyo.dairi" />
      </div>
      <div v-show="firstPart <= 3 && lastPart >= 3">
        <BrowseBuildingSekkei :sekkeis="gaiyo.sekkei"
          :useAdditional="useAdditional" :additional="gaiyo.sekkeiAdditional"
          :startIndex="sekkeiStart" :endIndex="sekkeiEnd" />
      </div>
      <div v-show="firstPart <= 4 && lastPart >= 4">
        <BrowseBuildingIken :ikens="gaiyo.iken"
          :startIndex="ikenStart" :endIndex="ikenEnd" />
      </div>
      <div v-show="firstPart <= 5 && lastPart >= 5">
        <BrowseBuildingKanri :kanris="gaiyo.kanri"
          :startIndex="kanriStart" :endIndex="kanriEnd" />
      </div>
      <div v-show="firstPart <= 6 && lastPart >= 6">
        <BrowseBuildingSeko :sekos="gaiyo.seko"
          :startIndex="sekoStart" :endIndex="sekoEnd" />
      </div>
      <div v-show="firstPart <= 7 && lastPart >= 7">
        <hr>
        <div class="gaiyo-row">
          <div class="gaiyo-major-title">【7.備考】</div>
        </div>
        <div class="gaiyo-row">
          <div class="gaiyo-element left-08">{{gaiyo.gaiyoRec.bkN_NAME_KANJI}}</div>
          <div v-for="(n,index) in wordwrap(gaiyo.gaiyoRec.bkN_NAME_KANJI,40)" :key="`bkn-name-${index}`">
            <br v-show="index>0"></div><br>
        </div>
        <div class="gaiyo-row">
          <div class="gaiyo-element left-08">{{gaiyo.gaiyoRec.bikO_NAIYO}}</div>
          <div v-for="(n,index) in wordwrap(gaiyo.gaiyoRec.bikO_NAIYO,40)" :key="`biko-nayo-${index}`">
            <br v-show="index>0"></div><br>
        </div>
        <hr>
      </div>
    </div>
  </section>
</template>

<script>
import BrowseBuildingOwner from './building/BrowseBuildingOwner.vue'
import BrowseBuildingDairi from './building/BrowseBuildingDairi.vue'
import BrowseBuildingSekkei from './building/BrowseBuildingSekkei.vue'
import BrowseBuildingIken from './building/BrowseBuildingIken.vue'
import BrowseBuildingKanri from './building/BrowseBuildingKanri.vue'
import BrowseBuildingSeko from './building/BrowseBuildingSeko.vue'

export default {
  components: {
    BrowseBuildingOwner,
    BrowseBuildingDairi,
    BrowseBuildingSekkei,
    BrowseBuildingIken,
    BrowseBuildingKanri,
    BrowseBuildingSeko,
  },
  props: {
    firstPart: {
      type: Number,
      default: () => 1
    },
    lastPart: {
      type: Number,
      default: () => 7
    },
    ownerStart: {
      type: Number,
      default: () => 0
    },
    ownerEnd: {
      type: Number,
      default: () => 5
    },
    sekkeiStart: {
      type: Number,
      default: () => 0
    },
    sekkeiEnd: {
      type: Number,
      default: () => 5
    },
    useAdditional: {
      type: Boolean,
      default: () => false
    },
    ikenStart: {
      type: Number,
      default: () => 0
    },
    ikenEnd: {
      type: Number,
      default: () => 5
    },
    kanriStart: {
      type: Number,
      default: () => 0
    },
    kanriEnd: {
      type: Number,
      default: () => 5
    },
    sekoStart: {
      type: Number,
      default: () => 0
    },
    sekoEnd: {
      type: Number,
      default: () => 5
    },
    gaiyo: {
      type: Object,
      default: null
    },
  },
  computed: {
  },
  methods: {
    wordwrap(text, len) {
      let result = [];
      if (text && text.length) {
        let start = 0;
        for (let i = 0; i < text.length; i += len) {
          result.push(text.substr(start, len));
          start += len;
        }
      }
      return result;
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../styles/gaiyo.css";
</style>